module.exports = __webpack_public_path__ + "img/29.d888ed61.jpg";